import { useGetSearchResultsForMultipleQuery } from '../../graphql/search.generated';
import { EntityType } from '../../types.generated';

// the filter is optional and is used to add additional filters to the search query
// if the filter is not provided, no key is added to the search input
export const useGetRecommendations = (types: Array<EntityType>, filter?: any) => {
    const { data } = useGetSearchResultsForMultipleQuery({
        variables: {
            input: {
                types,
                query: '*',
                start: 0,
                count: 5,
                ...(filter && { orFilters: filter }),
            },
        },
    });

    const recommendedData = data?.searchAcrossEntities?.searchResults?.map((searchResult) => searchResult.entity) || [];
    return [recommendedData];
};
